import { useSelector } from "react-redux";
import { Outlet, useParams, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

const ProtectedRoute = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

  const [checked, setChecked] = useState(false);

  useEffect(() => {
    if (!isAuthenticated) {
      navigate(-1); // Go back if not authenticated
    } else {
      setChecked(true); // allow render when authenticated
    }
  }, [isAuthenticated, navigate]);

  return checked ? <Outlet /> : null;
};

export default ProtectedRoute;
